import { Layout } from "antd";
import React from "react";

import Header from "../../components/Authorized/Header";
import NewJobForm from "../../components/Client/NewJobForm";

const NewJobPage = () => {
  return (
    <Layout>
      <Header />
      <Layout.Content>
        <NewJobForm />
      </Layout.Content>
    </Layout>
  );
};

export default NewJobPage;
